import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isTrellisCompatibleComponent"];
import styled from 'styled-components';
import HorizontalEdgeToolbar from './HorizontalEdgeToolbar';
import { EDGE_TOOLBAR_HEIGHT } from './constants';
import { withNonTrellisComponent, withTrellisComponent } from '../withTrellisCompatibleHoc';

// Adjustment to "pull up" the rotated toolbar to the expected top left position
import { jsx as _jsx } from "react/jsx-runtime";
const TOP_ADJUSTMENT = -1 * EDGE_TOOLBAR_HEIGHT;
const VerticalEdgeToolbar = _ref => {
  let props = _objectWithoutPropertiesLoose(_ref, _excluded);
  let style = props.style;

  // If a custom top position is passed, make sure to combine it with the top adjustment, otherwise
  // it will be blown away by the overriding style
  if (style && style.top != null) {
    style = Object.assign({}, style, {
      // Pre-existing bug, will come back to this when we're sure we still need
      // this computation in the trellis version
      // @ts-expect-error Operator '+=' cannot be applied to types 'Top<string | number>' and 'number'.ts(2365)
      top: style.top += TOP_ADJUSTMENT
    });
  }
  return /*#__PURE__*/_jsx(HorizontalEdgeToolbar, Object.assign({
    dropdownPlacement: "right"
  }, props, {
    style: style
  }));
};
export const LegacyVerticalEdgeToolbar = styled(withNonTrellisComponent(VerticalEdgeToolbar)).withConfig({
  displayName: "VerticalEdgeToolbar__LegacyVerticalEdgeToolbar",
  componentId: "o05klf-0"
})([".hs-private.hs-private.hs-private &{transform:rotate(270deg) translate(-100%,0);transform-origin:left bottom 0;position:relative;top:", "px;}"], TOP_ADJUSTMENT);
export const TrellisVerticalEdgeToolbar = styled(withTrellisComponent(VerticalEdgeToolbar)).withConfig({
  displayName: "VerticalEdgeToolbar__TrellisVerticalEdgeToolbar",
  componentId: "o05klf-1"
})([".hs-private.hs-private.hs-private &{transform:rotate(270deg) translate(-100%,0);transform-origin:left bottom 0;position:relative;top:", "px;}"], TOP_ADJUSTMENT);
export default LegacyVerticalEdgeToolbar;